
import {mapActions, mapGetters} from "vuex";
import {api, removeApiAuthToken} from "@/middleware/api";
import {removeUserAuthToken} from "@/middleware/auth";

export default {
    computed: {
        ...mapGetters('user', ['me', 'isRole']),
    },
    methods: {
        ...mapActions('user', ['LOGOUT']),
        async logout(rout = '/') {
            this.IS_GLOBAL_LOADING(true)
            await api.auth.authControllerLogout().then(async r => {
                this.LOGOUT();
                removeUserAuthToken();
                removeApiAuthToken();
                await this.$router.push(rout);
                window.location.reload();
            }).catch(e => this.alertError(e)).finally(() => {
                this.IS_GLOBAL_LOADING(false)
            })
        },

        isUserName(user, isActiveWhiteSpace = false, isActivePartrymic = true) {
            let customerProfile = user?.profile
            let name = '-';
            if(customerProfile) {
                name = isActivePartrymic
                    ? `${ customerProfile.firstName || '-' } ${ customerProfile.middleName || '-' } ${ customerProfile.lastName || '-' }`
                    : `${ customerProfile.firstName || '-' } ${ customerProfile.lastName || '-' }`
            }
            if(isActiveWhiteSpace) {
                name = name?.split(/(\s+)/)
                if(name) {
                    if (name.length > 1) {
                        name[0] = `${name[0]}\n`;
                        name[1] = ``;
                    }
                    name = name.join('');
                }
            }
            return name;
        }
    }
}